// extracted by mini-css-extract-plugin
export default {"submitting":"SimpleCard_submitting__icJop","headerText":"SimpleCard_headerText__1P-ui"};